import { Alert, Button, Col, Input, Modal, Row, message } from "antd";
import GoogleMapReact from "google-map-react";
import { useContext, useEffect, useState } from "react";
import { BiLeftArrowAlt } from "react-icons/bi";
import { BsChevronRight } from "react-icons/bs";
import { CiUser } from "react-icons/ci";
import { FiSearch } from "react-icons/fi";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { TbLocationFilled } from "react-icons/tb";
import OtpInput from "react-otp-input";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import axios from "../../config/axios";
import styles from "./LocationModal.module.scss";

const LocationModal = ({ setShowLocModal }) => {
  const [zip, setZip] = useState("");
  const { location, saveLocation } = useContext(AuthContext);
  const [address, setAddress] = useState(null);
  const [invalidZip, setInvalidZip] = useState(false);
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [predictions, setPredictions] = useState(null);
  const [coOrds, setCoOrds] = useState({
    lat: null,
    lng: null,
  });
  const [selectedLoc, setSelectedLoc] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const onSubmitHandler = () => {
    if (invalidZip) {
      setErrorMessage("Please enter a valid zip code");
      return;
    }

    if (zip.length !== 5) {
      setErrorMessage("Please enter 5 digit zip code");
      return;
    }

    if (address.city === "München") {
      let finalAddress = {
        ...address,
        ...selectedLoc,
        zip: zip,
      };
      saveLocation(finalAddress);
      setStep(2);
    } else {
      setStep(4);
    }
  };

  const onChangeHandler = (e) => {
    if (e.length === 5) {
      fetch("/germany.json")
        .then((response) => response.json())
        .then((json) => {
          let loc = json.filter((d) => d.zip === e)[0];
          if (!loc) {
            setInvalidZip(true);
          } else {
            setInvalidZip(false);
            setAddress(loc);
          }
        });
    }
    setZip(e);
  };

  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  const handleEmailSubmit = () => {
    if (!email) {
      message.error("Please enter your email!");
      return;
    }

    if (!validateEmail(email)) {
      message.error("Please enter a valid email!");
      return;
    }

    let payload = {
      name: "Anonymous",
      email: email,
      subject: "Location Request",
      message: `Location Request from ${address.city} - ${zip}`,
    };

    axios.post("/contact-us/submit", payload).then((_) => {
      message.success(
        `Subscribed successfully! We'll notify you when we start operating at ${
          location?.city ?? ""
        }`,
      );
      setShowLocModal(false);
    });
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      axios
        .get(
          `/public/fundamentals/search/location?search_term=${zip}, ${searchTerm}`,
        )
        .then((response) => {
          // console.log(response.data)
          setPredictions(response.data.predictions);
        });
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const handlePlaceSelect = (place_id) => {
    axios
      .get(`/public/fundamentals/place?place_id=${place_id}`)
      .then((response) => {
        console.log(response.data.result.geometry.location);
        setCoOrds(response.data.result.geometry.location);
        setSelectedLoc(response.data.result);
        setStep(3);
      });
  };

  const confirmLoc = async () => {
    let finalAddress = {
      ...address,
      ...selectedLoc,
      coOrdinates: coOrds,
      zip: zip,
    };
    // wait for the account to be updated before the reload throws this page away
    await saveLocation(finalAddress);
    setShowLocModal(false);
    window.location.reload();
  };

  // handle current location
  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        setCoOrds({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setStep(3);

        // get zip code from lat lng
        const { data } = await axios.get(
          "/public/fundamentals/place/reverse-geocode",
          {
            params: {
              lat: position.coords.latitude,
              long: position.coords.longitude,
            },
          },
        );

        console.log(data);
      });
    } else {
      setErrorMessage("Geolocation is not supported by this browser.");
    }
  };

  return (
    <Modal
      open={true}
      footer={null}
      centered={true}
      width={window.innerWidth > 576 ? "50%" : "100%"}
      style={
        window.innerWidth > 576 ? { maxWidth: "650px" } : { maxWidth: "95%" }
      }
      onCancel={() => setShowLocModal(false)}
      bodyStyle={
        window.innerWidth > 576 ? { padding: "24px" } : { padding: "0px" }
      }
      closeIcon={<IoCloseCircleOutline size={25} />}
    >
      <div className={styles.modal}>
        <Row style={{ width: "100%" }}>
          <Col lg={8} xs={24}>
            {step === 2 && (
              <div className="position-relative d-block d-sm-none">
                <div
                  className={styles.back_btn}
                  onClick={() => setStep(step - 1)}
                >
                  <BiLeftArrowAlt size={20} />
                  Back
                </div>
              </div>
            )}

            <div className={styles.left}>
              <em>Check if we deliver to your address</em>
              <span className="d-none d-sm-block">
                Get all your favorites delivered right to you door.
              </span>
              <img src="/icon/location_box.svg" alt="" />
            </div>
          </Col>
          <Col lg={16} xs={24}>
            {step === 1 ? (
              <div className={styles.right}>
                <b>Enter your zip code</b>
                <OtpInput
                  value={zip}
                  onChange={(e) => onChangeHandler(e)}
                  numInputs={5}
                  separator={
                    <span style={{ color: "rgba(128, 128, 128, 0.36)" }}>
                      |
                    </span>
                  }
                  inputStyle={styles.box}
                  containerStyle={styles.container_box}
                  placeholder={"80686"}
                  isInputNum={true}
                  shouldAutoFocus={true}
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button onClick={onSubmitHandler} type={"primary"}>
                    Check Now
                  </Button>
                </div>
                <div
                  className={styles.current_location}
                  onClick={getCurrentLocation}
                >
                  <TbLocationFilled size={20} color={"var(--color-primary)"} />
                  <div>
                    <b>Use my current location</b>
                    <span>This need location permission</span>
                  </div>
                </div>
                {errorMessage && (
                  <Alert message={errorMessage} type="error" showIcon />
                )}
              </div>
            ) : step === 2 ? (
              <div className={styles.right}>
                <div
                  className={`${styles.back_btn} d-none d-sm-block`}
                  onClick={() => setStep(step - 1)}
                >
                  <BiLeftArrowAlt size={20} />
                  Back
                </div>
                <b style={{ fontSize: "1.7rem" }}>
                  Please enter your delivery address:
                </b>
                <span style={{ fontSize: "1.3rem" }}>
                  e.g. Königsteinstraße 1/3, 80807 München
                </span>

                <Input
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ height: "40px" }}
                  size={"large"}
                  placeholder={"Enter your delivery address here"}
                  type={"text"}
                  prefix={<FiSearch size={20} />}
                />
                <div>
                  {predictions?.map((loc, index) => {
                    return (
                      <div
                        key={index}
                        className={styles.loc}
                        onClick={() => handlePlaceSelect(loc.place_id)}
                      >
                        <div>
                          <b>{loc.structured_formatting.main_text}</b>
                          <span>
                            {loc.structured_formatting.secondary_text}
                          </span>
                        </div>
                        <BsChevronRight
                          size={25}
                          color={"var(--color-primary)"}
                        />
                      </div>
                    );
                  })}
                </div>

                <div
                  className={styles.current_location}
                  onClick={getCurrentLocation}
                >
                  <TbLocationFilled size={20} color={"var(--color-primary)"} />
                  <div>
                    <b>Use my current location</b>
                    <span>This need location permission</span>
                  </div>
                </div>
              </div>
            ) : step === 3 ? (
              <div className={styles.right}>
                <div
                  className={styles.back_btn}
                  onClick={() => setStep(step - 1)}
                >
                  <BiLeftArrowAlt size={20} />
                  Back
                </div>
                <UserLocationMap
                  coOrds={coOrds}
                  setCoOrds={setCoOrds}
                  setZip={setZip}
                />
                <b>I am located here</b>
                <span>
                  Enjoy the offers & discounts with Desi Family membership
                </span>

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={confirmLoc}
                    style={{ width: "fit-content" }}
                    size={"large"}
                    type={"primary"}
                  >
                    Shop Now
                  </Button>
                </div>
              </div>
            ) : (
              <div className={styles.right}>
                <b style={{ textAlign: "center", fontSize: "1.8rem" }}>
                  We'll be in your area soon
                </b>
                <span style={{ textAlign: "center" }}>
                  Be the first to know when Desi Fresh opens a Store near you
                </span>

                <Input
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ height: "40px" }}
                  size={"large"}
                  placeholder={"Email"}
                  type={"email"}
                  prefix={<MdEmail size={20} />}
                />
                <p style={{ color: "grey" }}>
                  Your data will not be used to inform when Desi Fresh delivers
                  to your address. you can find more information in our{" "}
                  <Link
                    to={"/"}
                    style={{
                      color: "var(--color-primary)",
                      textDecoration: "underline",
                    }}
                  >
                    privacy policy
                  </Link>
                  .
                </p>
                <Button
                  onClick={handleEmailSubmit}
                  style={{ height: "40px" }}
                  size={"large"}
                  type="primary"
                >
                  Join Waitlist
                </Button>
                <Button
                  onClick={() => setShowLocModal(false)}
                  style={{
                    height: "40px",
                    backgroundColor: "var(--color-light-grey)",
                  }}
                  size={"large"}
                  type="ghost"
                >
                  Now Now
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default LocationModal;

const UserLocationMap = ({ coOrds, setCoOrds, setZip }) => {
  return (
    <div style={{ height: "200px", width: "100%", position: "relative" }}>
      <div className={styles.marker}>
        <CiUser size={20} color={"white"} />
      </div>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
        center={coOrds}
        defaultZoom={18}
        onChange={async (e) => {
          setCoOrds(e.center);

          // get zip code from lat lng
          const { data } = await axios.get(
            "/public/fundamentals/place/reverse-geocode",
            {
              params: {
                lat: e.center.lat,
                long: e.center.lng,
              },
            },
          );

          console.log(data);
        }}
      ></GoogleMapReact>
    </div>
  );
};
